import {
  missionWordingOf,
  resolvePageMissionKind,
} from '../app/utils/mission-page-naming.util';
import { useMissionContextOptional } from '../contexts/MissionContext/hooks/useMissionContextOptional.hook';
import type { MissionWording } from '../app/utils/mission-kind-profile.util';

import { useMissionSpace } from './useMissionSpace.hook';

// How the pages of the current mission name it in their titles.
export const useMissionSpaceWording = (): MissionWording =>
  missionWordingOf(
    resolvePageMissionKind(
      useMissionContextOptional()?.mission?.kind,
      useMissionSpace(),
    ),
  );
